export const AT_CARDS_ADD = 'CARDS_CARDS_ADD';
export const AT_CARDS_UPDATE = 'CARDS_CARDS_UPDATE';
export const AT_CARDS_DELETE = 'CARDS_CARDS_DELETE';
export const AT_CARD_ACTION_SET = 'CARDS_CARD_ACTION_SET';
